var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendToDoctorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4756 16.0464H17.0352V23.4863H10.4756V16.0464Z",
    fill: "#EA925C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9758 10.3095V7.08557C20.9758 3.1723 17.7623 0 13.7982 0C13.798 0 13.7979 0 13.7977 0C9.83362 0 6.62012 3.1723 6.62012 7.08557V10.3091L20.9758 10.3095Z",
    fill: "#EA925C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3846 25.8462L24.4615 28.1539C24.4615 28.1539 20.3077 27.2308 18.4615 28.6154C16.6154 30 17.5384 32.3005 17.5384 32.3005H0V26.5043C0.000935701 24.6457 1.13805 22.9713 2.87946 22.2644L10.4882 19.3846L13.768 22.667L17.051 19.3851L24.6566 22.2649C25.3846 22.667 26.3076 23.0769 27.2307 24C27.2307 24 26.3076 24 25.3846 25.8462Z",
    fill: "#EA925C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0344 8.23619V13.0236C19.0331 15.8942 16.6755 18.2205 13.7676 18.2205C10.8589 18.2205 8.50098 15.8928 8.50098 13.0214V8.38907L10.1845 8.33888C11.7932 8.29115 13.369 7.87718 14.7889 7.12929L16.9459 5.99329C17.7718 6.61201 18.4791 7.37168 19.0344 8.23619Z",
    fill: "#EA925C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4947 11.2035C21.4947 12.2934 20.5997 13.1769 19.4957 13.1769H19.0352V9.23022H19.4975C20.6009 9.23123 21.4947 10.1144 21.4947 11.2035Z",
    fill: "#EA925C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04004 11.2035C6.04004 12.2934 6.93504 13.1769 8.03909 13.1769H8.49961V9.23022H8.03729C6.93387 9.23123 6.04004 10.1144 6.04004 11.2035Z",
    fill: "#EA925C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.478 36.0004C25.1092 36.0004 24.7625 35.7897 24.5564 35.4356L22.67 32.1929H20.4934C19.882 32.1929 19.3857 31.6243 19.3857 30.9237C19.3857 30.2231 19.882 29.6545 20.4934 29.6545H23.2627C23.6326 29.6545 23.9782 29.8664 24.1843 30.2193L25.3407 32.2068L27.8097 26.5476C27.9914 26.1338 28.3536 25.8647 28.7579 25.847C29.1877 25.8355 29.5422 26.0653 29.7504 26.4612L32.7511 32.1929H34.8934C35.5048 32.1929 36.0011 32.7614 36.0011 33.462C36.0011 34.1626 35.5048 34.7312 34.8934 34.7312H32.1242C31.7354 34.7312 31.3743 34.4977 31.1749 34.1157L28.8897 29.7522L26.4694 35.2998C26.2922 35.7047 25.9411 35.9712 25.5467 35.9991C25.5246 36.0004 25.5013 36.0004 25.478 36.0004Z",
    fill: "#EA925C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendToDoctorIcon);
export default __webpack_public_path__ + "static/media/sendToDoctorIcon.e3ee2cf78b16cc6e1088a8c4d75579fb.svg";
export { ForwardRef as ReactComponent };